var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { Text, TEXT_SIZE } from "../Text";
import { useAutoFocus, useCapsLockDetector, useLoginFormSubmit } from "./hooks";
import { maxLength, required, useForm, useModel, useModelBuilder } from '@veeam/core';
import { CheckboxField, PasswordField, TextField } from "../fields";
import { SIZE_XL, useStateValue } from "../helpers";
import { Button } from "../Button";
import { INDENT } from "../View";
import { ErrorMessage } from "../ErrorMessage";
import { Notification, NOTIFICATION_STATUS } from "../Notification";
import { Spinner } from "../Spinner";
import { CONTROL_SIZE } from "../common/public";
var DEFAULT_TEXTS = {
    formTitle: 'Create user',
    actionLogIn: 'Log in',
    labelLogin: 'Username:',
    labelPassword: 'Password:',
    labelPasswordConfirm: 'Repeat password:',
    labelRememberMe: 'Remain logged in',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    errorPasswordDontMatch: 'Passwords do not match.',
    warningCapsLockOn: 'Caps Lock is on',
    helpTextPassword: 'Password should be at least 8 characters with one digit, one uppercase and one lowercase. Monotonic sequences such as 1234 are not allowed.'
};
var LoginButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 112px;\n"], ["\n    min-width: 112px;\n"])));
var FIELD_SIZE = '320px';
// TODO: remove after custom field size - Req278819
var FormContainer = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    [data-field-control-container='true'] {\n        width: 320px;\n    }\n"], ["\n    [data-field-control-container='true'] {\n        width: 320px;\n    }\n"])));
var Title = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: ", ";\n    line-height: ", ";\n"], ["\n    height: ", ";\n    line-height: ", ";\n"])), SIZE_XL, SIZE_XL);
export function CreateUser(_a) {
    var _this = this;
    var loading = _a.loading, _b = _a.hasRememberMe, hasRememberMe = _b === void 0 ? true : _b, customTexts = _a.texts, logIn = _a.logIn;
    var texts = Object.assign({}, DEFAULT_TEXTS, customTexts);
    var passwordDontMatchErrorState = useStateValue('');
    var busyModel = useModelBuilder({ loading: false });
    var inputRef = useAutoFocus();
    var form = useForm({ login: '', password: '', passwordConfirm: '', rememberMe: false }, {
        validationSchema: {
            login: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)],
            password: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)],
            passwordConfirm: [
                required(texts.errorRequired),
                maxLength(255, texts.errorMaxLength)
            ]
        }
    });
    var internalLoading = useModel(busyModel).value.loading;
    var isCapsLockActive = useCapsLockDetector();
    var onSubmit = function (payload) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (form.getValue().password !== form.getValue().passwordConfirm) {
                passwordDontMatchErrorState.setValue(texts.errorPasswordDontMatch);
                return [2 /*return*/];
            }
            passwordDontMatchErrorState.setValue('');
            return [2 /*return*/, logIn === null || logIn === void 0 ? void 0 : logIn(payload)];
        });
    }); };
    var _c = useLoginFormSubmit({
        form: form,
        handler: onSubmit,
        busyModel: busyModel
    }), submit = _c.submit, errorHighlight = _c.errorHighlight, fieldFocusHandler = _c.fieldFocusHandler, keyDownHandler = _c.keyDownHandler, hasError = _c.hasError, error = _c.error;
    loading = loading || internalLoading;
    var hasDontMatchError = !!passwordDontMatchErrorState.getValue();
    var hasMessages = hasError || isCapsLockActive || hasDontMatchError;
    useEffect(function () {
        var sub = form.model.subscribe(function () {
            if (passwordDontMatchErrorState.getValue()) {
                passwordDontMatchErrorState.setValue('');
            }
        });
        return function () {
            sub.unsubscribe();
        };
    }, []);
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, onKeyDown: keyDownHandler },
        React.createElement(FormContainer, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, align: STACK_ALIGN.end },
            React.createElement(StackView, { align: STACK_ALIGN.start, direction: STACK_DIRECTION.column, gap: STACK_GAP.s, size: { width: FIELD_SIZE } },
                React.createElement(Title, { size: TEXT_SIZE.xl, trailer: hasMessages ? INDENT.none : INDENT.l }, texts.formTitle),
                hasError && React.createElement(ErrorMessage, null, error),
                hasDontMatchError && (React.createElement(ErrorMessage, null, passwordDontMatchErrorState.getValue())),
                isCapsLockActive && (React.createElement(Notification, { status: NOTIFICATION_STATUS.warning }, texts.warningCapsLockOn))),
            React.createElement(TextField, { inlineLabel: true, helpTextWrap: true, size: CONTROL_SIZE.full, label: texts.labelLogin, field: form.fields.login, hasError: errorHighlight, onFocus: fieldFocusHandler, disabled: loading, controlRef: inputRef }),
            React.createElement(PasswordField, { inlineLabel: true, label: texts.labelPassword, helpTextWrap: true, size: CONTROL_SIZE.full, field: form.fields.password, hasError: errorHighlight || hasDontMatchError, onFocus: fieldFocusHandler, disabled: loading, helpText: texts.helpTextPassword }),
            React.createElement(PasswordField, { inlineLabel: true, helpTextWrap: true, size: CONTROL_SIZE.full, label: texts.labelPasswordConfirm, field: form.fields.passwordConfirm, onFocus: fieldFocusHandler, disabled: loading, hasError: errorHighlight || hasDontMatchError }),
            React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, align: STACK_ALIGN.start, size: { width: FIELD_SIZE } },
                hasRememberMe && (React.createElement(CheckboxField, { field: form.fields.rememberMe, label: texts.labelRememberMe, disabled: loading })),
                React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, indentTop: hasRememberMe ? INDENT.none : INDENT.s, align: STACK_ALIGN.center },
                    React.createElement(LoginButton, { onClick: submit, disabled: loading }, texts.actionLogIn),
                    loading && React.createElement(Spinner, null))))));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CreateUser.js.map